// extracted by mini-css-extract-plugin
export var background = "Pricing-module--background--NhaEz";
export var container = "Pricing-module--container--szl6L";
export var list = "Pricing-module--list--VDLRo";
export var listItem = "Pricing-module--listItem--tBSL2";
export var name = "Pricing-module--name--lzwCd";
export var newPrice = "Pricing-module--newPrice--HhTQp";
export var oldPrice = "Pricing-module--oldPrice--+0cCZ";
export var priceList = "Pricing-module--priceList--MVrAU";
export var red = "Pricing-module--red--H7mBO";